<template>
  <div class="order-item-warp">
    <div class="order-item-main">
      <div
        v-if="
          (item.pZujie == 3 || item.pZujie == 5) &&
          (item.pFukuan == 0 || item.pAlipayjsSm == '代扣支付失败')
        "
        class="order-item-title unpay"
      >
        <div>{{ typeMap[6] }}</div>
        <div class="pay" @click="handleClick(item)">{{ i18n.pay }}</div>
      </div>
      <div v-else class="order-item-title">{{ typeMap[item.pZujie] }}</div>
      <p>
        <span>{{ i18n.order_number }}</span
        >{{ item.pOrderid }}
      </p>
      <p>
        <span>{{ i18n.time_rented }}</span
        >{{ item.pBorrowtime | dateFmt }}
      </p>
      <p>
        <span>{{ i18n.venue_rented }}</span
        >{{ item.pShopName }}
      </p>
    </div>
    <div class="order-item-foot" v-if="!isZujie">
      <div>
        <img src="../../assets/imgs/icon_time.png" alt="" />
        <span>{{ item.pUseMins }} {{ i18n.min }}</span>
      </div>
      <div>
        <img src="../../assets/imgs/icon_money.png" alt="" />
        <span>{{ item.pJiesuan }} {{ currency }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { PAY_ORDER_GOPAY } from "../../apis/cabinet"
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters(["locale"]),
    i18n() {
      return this.$t("order_item")
    },
    i18nMsg() {
      return this.$t("msg")
    },
    i18nConfirm() {
      return this.$t("confirm")
    },
    currency() {
      return this.item.pCurrency || this.locale.money
    },
    isZujie() {
      return (
        this.item.pJiesuanid === 0 &&
        (this.item.pZujie === 1 || this.item.pZujie === 4)
      )
    },
    lang() {
      return this.$store.state.lang.split("-")[0] || "en"
    }
  },
  data() {
    return {
      typeMap: {}
    }
  },
  created() {
    this.typeMap = {
      0: this.i18n.type_0,
      1: this.i18n.type_1,
      2: this.i18n.type_2,
      3: this.i18n.type_3,
      4: this.i18n.type_4,
      5: this.i18n.type_5,
      6: this.i18n.type_6
    }
  },
  methods: {
    handleClick(item) {
      this.$post(
        `${PAY_ORDER_GOPAY}?outTradeNo=${item.pOrderid}&paymentId=17&continueUrl=https://energy-point-sharing.eu/#/order&language=${this.lang}`,
        {},
        (resp) => {
          // console.log(resp)
          if (resp.code === 0) {
            const data = resp.data
            if (data.order_number) {
              location.href = data.gw_url
            } else {
              this.$toast(this.i18nMsg.title_fail)
            }
          }
        },
        (error) => {
          this.$loading(false)
          console.log(error)
          this.$confirm({
            title: this.i18nMsg.confirm,
            content: error,
            confirmText: this.i18nConfirm.msg_fail_confirm,
            showCancel: false
          })
            .then(() => {})
            .catch(() => {})
        }
      )
    }
  }
}
</script>

<style lang="less">
.unpay {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pay {
  width: 180px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  padding: 0 3px;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 1px 2px 10px #ccc;
}
.order-item-warp + .order-item-warp {
  margin-top: 40px;
}
.order-item-warp {
  background-color: #fff4e9;
  padding: 0 24px;
  border-radius: 20px;
  color: #727070;
  font-size: 24px;
  line-height: 40px;
  box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.2);
  .order-item-main {
    padding: 40px 24px 1px;
    span {
      padding-right: 24px;
    }
  }
  .order-item-title {
    font-size: 32px;
    color: #444444;
  }
  .order-item-foot {
    display: flex;
    justify-content: flex-start;
    border-top: 2px dashed #707070;
    padding: 0 24px;
    div {
      height: 80px;
      width: 50%;
      flex: 1;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    img {
      height: 40px;
      width: 40px;
      margin-right: 20px;
    }
  }
}
</style>
